import { jsxs as l, jsx as h } from "react/jsx-runtime";
const c = (r) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...r,
    children: [
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M46.857 35.74c-6.138 0-11.114 4.975-11.114 11.114 0 6.139 4.975 11.114 11.114 11.114 6.139 0 11.114-4.975 11.114-11.114 0-6.139-4.975-11.114-11.114-11.114Zm0 19.23c-4.476 0-8.117-3.641-8.117-8.117 0-4.476 3.641-8.117 8.117-8.117 4.476 0 8.117 3.641 8.117 8.117 0 4.476-3.641 8.117-8.117 8.117Z"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M33.795 47.978H10.024V31.996h43.951v3.852a13.201 13.201 0 0 1 3.996 4.058V12.018H10.029a4 4 0 0 0-4 4v31.956a4 4 0 0 0 4 4h24.759a13.02 13.02 0 0 1-.993-3.996ZM10.024 16.014h43.951v5.993H10.024v-5.993Zm0 7.991h43.951v5.993H10.024v-5.993Z"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M47.736 49.852h-2.133c.732-.489 1.009-1.27 1.009-2.035 0-.098 0-.196-.016-.293h2.295v-1.791h-2.865c-.163-.424-.277-.798-.277-1.286 0-.863.602-1.27 1.254-1.27.846 0 1.303.569 1.319 1.562l2.133-.569c-.082-1.335-.977-3.012-3.483-3.012-2.279 0-3.581 1.611-3.581 3.207 0 .537.081.977.212 1.367h-.928v1.791h1.579c.033.179.065.358.065.537 0 .96-.667 1.628-1.693 1.986v1.921h5.437c1.807 0 3.028-1.352 3.028-3.19l-2.149-.13c0 .732-.52 1.205-1.205 1.205h-.001Z"
        }
      )
    ]
  }
);
export {
  c as TopUpCardOrKey
};
